import React from 'react';
import classNames from 'classnames';
import { bool } from 'prop-types';
import { Col } from '@thd-olt-component-react/core-ui';
import { AddToCart } from '@thd-olt-component-react/add-to-cart';
import { useOrderAPackageContext } from '../../../OrderAPackageContext';
import {
  GEN_MERCH_PACKAGE,
  KITCHEN_PACKAGE,
  MCC_FULFILLMENT_METHOD_DIRECT_DELIVERY,
} from '../../constants';

import './addToCartButton.scss';
import { getQuantityError } from '../../fulfillmentUtils';

const enhanceMetadataOptions = (metadata) => {
  return {
    brandImage: metadata.brandImage?.url || '',
    heroImage: metadata.heroImage?.url || '',
    packageBrand: metadata.brandName,
    packageImage: metadata.image?.url?.replace(/<SIZE>/g, '400') || '',
    packageName: metadata.name
  };
};

const buildCartRequestParams = (itemIds, isMajorAppliancePackage, products, zipCode) => {
  const fulfillmentMethod = isMajorAppliancePackage ? MCC_FULFILLMENT_METHOD_DIRECT_DELIVERY : null; //eslint-disable-line
  return itemIds.map((itemId) => ({ itemId,
    quantity: products.get(itemId).selectedQty,
    fulfillmentMethod,
    fulfillmentLocation: zipCode || '' }));
};

export const AddToCartButton = ({ landscape, forHeader }) => {
  const { state, channel } = useOrderAPackageContext();
  const isMobile = channel === 'mobile';
  const { selectedProductIds, isMajorAppliancePackage, metadata, products } = state;
  const shouldHideMainAddToCartButton = (!landscape && !forHeader && isMobile);
  const isLandscapeHeaderMobile = (landscape && forHeader && isMobile);

  const isAddToCartDisabled = !state.isMajorAppliancePackage && (
    Array.from(state.products.values()).some((product) => product.productGroupSelected &&
    (product.isOutOfStock || getQuantityError(true, product, false))));

  const zipCode = typeof window !== 'undefined' ? window.cookieUtils?.readBrowserCookie?.('DELIVERY_ZIP') : '';

  const classes = classNames({
    'add-to-cart-button--hidden': shouldHideMainAddToCartButton,
    'add-to-cart-button--smaller-font': isLandscapeHeaderMobile
  });

  const getHostName = () => {
    let host = 'https://www.homedepot.com';
    if (typeof window !== 'undefined') {
      const origin = window.location.origin;
      host = origin.match(/local/g) ? 'https://www.homedepot.com' : origin;
    }
    return host;
  };

  const getCartOptions = () => {
    const defaultParams = {
      host: getHostName(),
      channel,
      paypal: false,
      misship: false,
      sharedSection: isMajorAppliancePackage ? KITCHEN_PACKAGE : GEN_MERCH_PACKAGE,
    };
    if (isMajorAppliancePackage && selectedProductIds.length === 1) {
      return defaultParams;
    }
    return { ...defaultParams, packageInfo: { ...metadata, ...enhanceMetadataOptions(metadata) } };
  };

  return (
    <Col className={classes}>
      <AddToCart
        cartOptions={getCartOptions()}
        cartReqParams={buildCartRequestParams(selectedProductIds, isMajorAppliancePackage, products, zipCode)}
        disabled={isAddToCartDisabled}
      >
        Add Bundle to Cart
      </AddToCart>
    </Col>
  );
};

AddToCartButton.propTypes = {
  landscape: bool,
  forHeader: bool,
};

AddToCartButton.defaultProps = {
  landscape: false,
  forHeader: false,
};

AddToCartButton.displayName = 'AddToCartButton';
